function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 1l14 14m0-14L1 15",
  stroke: "currentColor",
  strokeWidth: 2
});

const SvgCross = props => React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _ref);

export default SvgCross;